import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralAutocompleteComponent } from '../../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { ContactsService } from '../../../../../../../core/lists/_services';
import { of } from 'rxjs';
import { LayoutUtilsService } from '../../../../../../../core/_base/crud';
import { StringUtilsService } from '../../../../../../../core/services/string-utils.service';

@Component({
  selector: 'kt-merge-contacts',
  templateUrl: './merge-contacts.component.html',
  styleUrls: ['./merge-contacts.component.scss'],
})
export class MergeContactsComponent implements OnInit, AfterViewInit {
  mergeForm: FormGroup;
  contactAutocompleteCall = this.contactsService.searchContacts.bind(this.contactsService);
  @ViewChild('contactAutocomplete') contactAutocomplete: GeneralAutocompleteComponent;
  formatFn = ((value) => {
    return value;
  }).bind(this);

  constructor(
    private contactsService: ContactsService,
    private fb: FormBuilder,
    public stringUtils: StringUtilsService,
    public dialogRef: MatDialogRef<MergeContactsComponent>,
    private layoutUtilsService: LayoutUtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.mergeForm = this.fb.group({
      contacts: [null, Validators.required],
    });
  }

  ngAfterViewInit() {
    this.contactAutocomplete.isLoading.subscribe((res) => {
      if (!res) {
        this.contactAutocomplete.filteredItems.subscribe((result) => {
          this.contactAutocomplete.filteredItems = of(
            result.filter((item) => item.id !== this.data.id),
          );
        });
      }
    });
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onMergeClick(): void {
    this.contactAutocomplete.updateValueAndValidity();
    this.mergeForm.markAllAsTouched();

    if (this.mergeForm.invalid) return;

    const _title = '';
    const _description = `
      <h1 class="font-weight-boldest mb-10">
        <span class="text-danger">
          <span class="flaticon2-warning svg-icon"></span>
          WARNING:
        </span>
        You are about to merge contacts.
      </h1>
      <p><span class="font-weight-bolder">Are you sure you want to proceed?</span> Selected contacts will be deactivated and all of their transactions (Relations, Notes, Communications, and Workflows) will be transferred to <span class="text-success">${this.getFullName(
        this.data,
      )}</span> contact.</p>
      <p><span class="font-weight-bolder">Note:</span> <span class="text-success">${this.getFullName(
        this.data,
      )}</span> contact's general info will remain as it is. So if you need to keep the general info of any of the selected contacts cancel this process and apply a new one on the contact that you need to keep his/her info or update this info manually.</p>
    `;
    const _waitDesciption = 'Merging...';

    const dialogR = this.layoutUtilsService.confirmAction(_title, _description, _waitDesciption);
    dialogR.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.dialogRef.close({
        contacts: this.mergeForm.get('contacts').value,
      });
    });
  }

  onContactChange(val) {
    this.mergeForm.controls.contacts.setValue(val);
  }

  getFullName(contact): string {
    return `${contact.first_name || ''} ${contact.middle_name || ''} ${contact.last_name || ''} ${
      contact.last_name2 || ''
    }`;
  }
}
